import { render, staticRenderFns } from "./GridHenderSortDom.vue?vue&type=template&id=21b4ee17&"
import script from "./GridHenderSortDom.vue?vue&type=script&lang=js&"
export * from "./GridHenderSortDom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports